module.exports = __webpack_public_path__ + "img/school-expenses.0b1762cb.png";